/* Pottkinder Multi-Slider */

$(document).ready(function() {

    /*store width of slider item*/
    var w;

    /*responsive behaviour of slider*/
    if ($(window).width() >= 992) {
        w = '-25%';
    }
    else if ($(window).width() < 992 && $(window).width() >= 576) {
        w = '-33.333%';
    }
    else if ($(window).width() < 576 && $(window).width() >= 400) {
        w = '-50%';
    }
    else if ($(window).width() < 400) {
        w = '-100%';
    }

    /*function which causes slider to slide to the left*/
    function slideToLeft() {
        $('.reference_slider_items').animate({left: w}, 1000, function () {
            $('.reference_slider_item:first-child').detach().appendTo($('.reference_slider_items'));
            $('.reference_slider_items').css({left: 0});
        });
    }

    /*function which causes slider to slide to the right*/
    function slideToRight() {
        $('.reference_slider_item:last-child').detach().prependTo($('.reference_slider_items'));
        $('.reference_slider_items').css({left: w});
        $('.reference_slider_items').animate({left: 0}, 1000, function () {
        });
    }

    /*start interval to run slider automatically*/
    var startSlider = setInterval(slideToLeft, 5000);

    /*event handler for left button*/
    $('.carousel-control-prev').on('click', function() {
        // clearInterval(startSlider);                             //stop interval
        $('.reference_slider_items').clearQueue();              //stop and finish running animations
        slideToRight();                                          //slide manually
        // startSlider = setInterval(slideToLeft, 5000);   //start interval again
    });

    /*event handler for right button*/
    $('.carousel-control-next').on('click', function() {
        // clearInterval(startSlider);                             //stop interval
        $('.reference_slider_items').clearQueue();              //stop and finish running animations
        slideToLeft();                                         //slide manually
        // startSlider = setInterval(slideToLeft, 5000);   //start interval again
    });

});

/* adjust class '.reference_slider_item' to your slider item */
/* adjust ids '#reference_right' and '#refenrence_left' to your slider controls */
